const isElectron = () => Boolean(window.electron)

export default isElectron
